import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBooking } from 'src/app/models/BookingList';
import { IUser, IUserStatus } from 'src/app/models/User';

interface IUserData {
    user: IUser;
    userStatus: IUserStatus;
}

interface AccountState {
    commonFilter: string;
    hasfilterApplied: boolean;
    records: any;
    userData: IUserData | null;
}

const initialState: AccountState = {
    commonFilter: '',
    hasfilterApplied: false,
    records: null,
    userData: null,
};

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setCommonFilter: (state, action: PayloadAction<string>) => {
            state.commonFilter = action.payload;
        },

        applyAccountFilter: (state) => {
            state.hasfilterApplied = true;
        },

        clearAllFilter: (state) => {
            state.hasfilterApplied = false;
            state.commonFilter = '';
        },

        setRecords: (state, action: PayloadAction<any>) => {
            state.records = action.payload;
        },

        setUser: (state, action: PayloadAction<IUserData | null>) => {
            state.userData = action.payload;
        },
    },
});

export const { setCommonFilter, applyAccountFilter, clearAllFilter, setRecords, setUser } = accountSlice.actions;
export default accountSlice.reducer;
